"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pulse_components_1 = require("@pcs/pulse-components");
const clsx_1 = __importDefault(require("clsx"));
const react_1 = __importStar(require("react"));
const helpers_1 = require("../helpers");
const new_round_available_modal_modules_less_1 = __importDefault(require("./new-round-available-modal.modules.less"));
const NewRoundAvailableModal = ({ open, ...restProps }) => {
    // const dispatch = useDispatch();
    const [openModal, setOpenModal] = (0, react_1.useState)(open);
    const handleClose = () => {
        setOpenModal(false);
    };
    const handleRedirectLastRound = () => {
        const { state } = window.history;
        const { hash } = window.location;
        if (state.redirectRound && state.lastRoundId && hash) {
            const [reviewIdDeepLink] = (0, helpers_1.useReviewIdByDeepLinks)(hash);
            window.location.hash = `${reviewIdDeepLink}`;
            window.history.replaceState({
                roundId: state.lastRoundId || 0,
            }, '');
        }
        handleClose();
    };
    return (react_1.default.createElement(pulse_components_1.PulseModalBase, { open: openModal, onModalClose: handleClose, headerPrimaryText: 'NEW ROUND AVAILABLE', classes: {
            root: [new_round_available_modal_modules_less_1.default['available-modal__root']],
            dialog: {
                paper: new_round_available_modal_modules_less_1.default['available-modal'],
            },
        }, PulseModalHeaderProps: {
            classes: {
                root: new_round_available_modal_modules_less_1.default['available-modal__header'],
            },
        }, headerIconClasses: (0, clsx_1.default)(new_round_available_modal_modules_less_1.default['modal-header__icon'], 'fal fa-info-circle'), ...restProps, footer: false, variant: "jqconfirm" },
        react_1.default.createElement("div", { className: new_round_available_modal_modules_less_1.default['available-modal__content'] },
            react_1.default.createElement("h3", { className: new_round_available_modal_modules_less_1.default['available-content__text'] }, "Should we redirect you to the new round ?"),
            react_1.default.createElement("div", { className: new_round_available_modal_modules_less_1.default['available-content__actions'] },
                react_1.default.createElement(pulse_components_1.PulseButton, { classes: [new_round_available_modal_modules_less_1.default['content-action']], label: "NO THANKS", onClick: handleClose }),
                react_1.default.createElement(pulse_components_1.PulseButton, { classes: [new_round_available_modal_modules_less_1.default['content-action']], label: "REDIRECT TO NEW ROUND", color: pulse_components_1.Colors.success, onClick: handleRedirectLastRound })))));
};
NewRoundAvailableModal.displayName = 'NewRoundAvailableModal';
exports.default = react_1.default.memo(NewRoundAvailableModal);
